import $ from 'jquery'

export class MenuPrimary {

  constructor() {
    this.$container = $('header.header nav.header-primary')
    if (!this.$container.length) {
      return
    }

    this.$body = $('body')
    this.isAdmin = !this.$body[0].classList.length || this.$body.hasClass('wp-admin');
    if ( this.isAdmin ) {
      return;
    }

    this.classes = {
      'header': 'header.header',
      'headerHidden': 'header-hidden',
      'headerScroll': 'header-scroll',
      'headerAnimation': 'header-animation',
      'bannerTopAnimation': 'banner-top-animation',
      'submenu': 'has-submenu',
      'submenuItems': 'submenu',
      'itemSubmenu': 'item-submenu',
      'burgerButton': 'burger-button',
      'submenuProduct': 'submenu-product',
      'submenuContent': 'submenu-content',
      'dataSubmenuLink': 'data-submenu-link',
      'dataSubmenuContent': 'data-submenu-content',
      'hasSublinks': 'has-sublinks',
      'sublinksVisible': 'sublinks-visible',
      'iconClose': 'icon-close_1',
      'iconBurger': 'icon-burger',
      'itemTitle': 'item-title',
      'linkReturn': 'link-return',
      'overlay': 'header-overlay',
      'submenuProductAllLink': 'submenu-product-all-link',
      'active': 'active'
    }
    this.bpHeader = 768
    this.bpHeaderDesktop = 1279
    this.$window = $(window)
    this.$html = $('html')
    this.$pageContent = $('.page-content')
    this.$header = $('header.header')
    this.$bannerTopContent = $('.banner-top-content')
    this.$submenu = this.$container.find(`.${this.classes.submenu} > .link`)
    this.$subItems = this.$container.find(`.${this.classes.submenuItems} > .container > ul > li > .link`)
    this.$itemTitle = this.$header.find(`.${this.classes.itemTitle} > .link`)
    this.$burgerButton = this.$header.find(`.${this.classes.burgerButton}`)
    this.$linkReturn = this.$header.find(`.${this.classes.linkReturn}`)
    this.$titleSublink = this.$header.find(`.${this.classes.hasSublinks} > .link`)
    this.$overlay = $(`.${this.classes.overlay}`);
    this.previousScroll = 0

    this.$submenu.on('click', this.handlerClickSubmenu.bind(this))
    this.$subItems.on('click', this.handlerClickSubmenuItems.bind(this))
    this.$itemTitle.on('click', this.handlerClickItemTitle.bind(this))
    this.$burgerButton.on('click', this.handlerClickMenuBurger.bind(this))
    this.$linkReturn.on('click', this.handlerClickLinkReturn.bind(this))
    this.$titleSublink.on('click', this.handlerClickTitleSublink.bind(this))
    this.$window.on('resize', this.handleResize.bind(this))
    this.$window.on('scroll', this.handleScroll.bind(this))
    $(document).on('click', this.handleClickDocument.bind(this))
  }

  handleScroll(e) {
    if (this.$header.hasClass(this.classes.active)) {
      e.preventDefault()
      return
    }

    let currentScroll = this.$window.scrollTop();
    let scrollTopPageContent = this.$pageContent.offset().top
    let scrollTopPageContentWithHeaderHeight = scrollTopPageContent + this.$header.outerHeight(true)

    if (currentScroll > this.previousScroll && currentScroll > scrollTopPageContentWithHeaderHeight) {
      this.$body.addClass(this.classes.headerHidden)
    } else {
      this.$body.removeClass(this.classes.headerHidden)
    }

    if (this.previousScroll < currentScroll) {
      // Scroll vers le bas
      if (currentScroll > scrollTopPageContentWithHeaderHeight) {
        this.$header.addClass(this.classes.headerScroll)
        setTimeout(this.addHeaderAnimationClass.bind(this), 50)
      } else {
        this.$header.removeClass(this.classes.headerScroll)
        setTimeout(this.removeHeaderAnimationClass.bind(this), 50)
      }
    } else {
      // Scroll vers le haut
      if (currentScroll > 0) {
        this.$header.addClass(this.classes.headerScroll)
        setTimeout(this.addHeaderAnimationClass.bind(this), 50)
      } else {
        this.$header.removeClass(this.classes.headerScroll)
        setTimeout(this.removeHeaderAnimationClass.bind(this), 50)
      }
    }

    this.previousScroll = currentScroll;

    // this.handleResize()

    if (currentScroll > 0) {
      return
    }

    this.$body.removeClass(this.classes.headerHidden)
    this.$header.removeClass(this.classes.headerScroll)
  }

  handlerClickSubmenu(e) {
    e.preventDefault()
    let $submenu = $(e.currentTarget).parent()

    if ($submenu.find(`.${this.classes.submenuProduct}`)) {
      if ($(window).width() < this.bpHeaderDesktop) {
        $submenu.find(`.${this.classes.active}`).removeClass(this.classes.active)
      } else if ($submenu.find(`.${this.classes.submenuContent}.${this.classes.active}`).length === 0) {
        $submenu.find('li').eq(0).addClass(this.classes.active)
        $submenu.find(`.${this.classes.submenuContent}`).eq(0).addClass(this.classes.active)
      }
    }

    if ($submenu.hasClass(this.classes.active)) {
      $submenu.parent().find(`.${this.classes.submenu}.${this.classes.active}`).removeClass(this.classes.active)
      this.$header.removeClass(this.classes.active)
      if ($(window).width() > this.bpHeaderDesktop) {
        this.$overlay.removeClass(this.classes.active);
      }
    } else {
      $submenu.parent().find(`.${this.classes.submenu}.${this.classes.active}`).removeClass(this.classes.active)
      $submenu.addClass(this.classes.active)
      this.$header.addClass(this.classes.active)
      if ($(window).width() > this.bpHeaderDesktop) {
        this.$overlay.addClass(this.classes.active);
      }
    }
  }

  handlerClickTitleSublink(e) {
    const $parent = $(e.currentTarget).parent()
    $parent.toggleClass(this.classes.sublinksVisible)
  }

  handlerClickSubmenuItems(e) {
    e.preventDefault()
    let $item = $(e.currentTarget)
    let $itemParent = $item.parent()

    $itemParent.closest('ul').find(`.${this.classes.active}`).removeClass(this.classes.active)
    $itemParent.addClass(this.classes.active)

    let dataSubmenuLink = $item.attr(this.classes.dataSubmenuLink)

    if (dataSubmenuLink) {
      let $submenu = $item.closest(`.${this.classes.submenuProduct}`)

      $submenu.find(`.${this.classes.active}[${this.classes.dataSubmenuContent}]`).removeClass(this.classes.active)
      $submenu.find(`[${this.classes.dataSubmenuContent}=${dataSubmenuLink}]`).addClass(this.classes.active)
    }
  }

  handlerClickMenuBurger(e) {
    e.preventDefault()

    if (this.$header.hasClass(this.classes.active)) {
      this.$header.removeClass(this.classes.active)
      this.$burgerButton.find('i').removeClass(this.classes.iconClose).addClass(this.classes.iconBurger)
    } else {
      this.$header.addClass(this.classes.active)
      this.$burgerButton.find('i').removeClass(this.classes.iconBurger).addClass(this.classes.iconClose)
    }
  }

  handlerClickLinkReturn(e) {
    e.preventDefault()
    let $linkReturn = $(e.currentTarget)
    $linkReturn.closest(`.${this.classes.active}`).removeClass(this.classes.active)
  }

  handlerClickItemTitle(e) {
    e.preventDefault()
    let $item = $(e.currentTarget)
    let dataSubmenuLink = $item.attr(this.classes.dataSubmenuLink)

    if (dataSubmenuLink) {
      $item.closest(`.${this.classes.submenuProduct}`).find(`[${this.classes.dataSubmenuContent}=${dataSubmenuLink}]`).addClass(this.classes.active)
    } else {
      $item.parent().find(`.${this.classes.itemSubmenu}`).addClass(this.classes.active)
    }
  }

  handleResize() {
    this.$header.find(`.${this.classes.active}`).removeClass(this.classes.active)
    this.$header.removeClass(this.classes.active)
    this.$burgerButton.find('i').removeClass(this.classes.iconClose).addClass(this.classes.iconBurger)
    this.$overlay.removeClass(this.classes.active)
  }

  /**
   * Événement au clic sur le document
   *
   * @param e
   */
  handleClickDocument(e) {
    let $element = $(e.target)
    let $header = $element.closest(`${this.classes.header}`)

    if ($header.length === 0) {
      this.handleResize()
    }
  }

  addHeaderAnimationClass() {
    this.$header.addClass(this.classes.headerAnimation)

    if (this.$bannerTopContent.length > 0) {
      this.$bannerTopContent.addClass(this.classes.bannerTopAnimation)
    }
  }

  removeHeaderAnimationClass() {
    this.$header.removeClass(this.classes.headerAnimation)

    if (this.$bannerTopContent.length > 0) {
      this.$bannerTopContent.removeClass(this.classes.bannerTopAnimation)
    }
  }
}
